import { render, staticRenderFns } from "./QcShoppingMall.vue?vue&type=template&id=96e4420a&scoped=true"
import script from "./QcShoppingMall.vue?vue&type=script&lang=js"
export * from "./QcShoppingMall.vue?vue&type=script&lang=js"
import style0 from "./QcShoppingMall.vue?vue&type=style&index=0&id=96e4420a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e4420a",
  null
  
)

export default component.exports